<template>
    <v-container>
        <v-layout>
            <v-flex xs12>
                <PublicHolidays></PublicHolidays>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import PublicHolidays from "./PublicHolidays.vue";

export default {
    components: {
        PublicHolidays
    },
    props: [
        
    ],
    data() {
        return {
            
        };
    },
    computed: {
        
    },
    methods: {
        
    }
};
</script>

<style>
    
</style>